import { Injectable, Injector } from '@angular/core';
import { BaseResourceService, FavorecidoDependente } from 'eddydata-lib';

@Injectable({
  providedIn: 'root'
})
export class FavorecidoDependenteService extends BaseResourceService<FavorecidoDependente> {

  constructor(
    protected injector: Injector
  ) {
    super(`favorecido-dependente`, injector);
  }

}